module.exports = __webpack_public_path__ + "media/store/images/instagram-ae293e6872ec9e04fc8eec67f8cf737b.svg";